import { HttpBadStatusCodeError } from '@cian/peperrors/shared';

export interface IParams {
  message: string;
  statusCode: number;
  domain: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  details?: any;
}

/**
 * Выбрасывает исключение
 */
export const throwError = (params: IParams) => {
  throw new HttpBadStatusCodeError(params);
};
